export default function getPassword(state) {
  if (state.loginForm && state.loginForm.password) {
    return state.loginForm.password;
  }
  return "";
}